export const getArrayIntersection = <T extends string>(
  array1: T[],
  array2: T[]
): T[] => array1.filter(value => -1 !== array2.indexOf(value));
